import Chart from 'chart.js/auto';
window.Chart = Chart;
import 'chartjs-chart-funnel';
const defaultLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
];
Chart.defaults.color = "#ffffff"
window.FacetTrak = window.FacetTrak || {};
window.FacetTrak.functions = window.FacetTrak.functions || {};
$(document).ready(function() {
    /*
     Line Chart Default
     */
    $('.linegraphDefault').each(function() {
        const lineData = {
            labels: defaultLabels,
            datasets: [{
                label: 'Example Line Graph',
                backgroundColor: 'rgb(255, 99, 132)',
                borderColor: 'rgb(255, 99, 132)',
                data: [0, 10, 5, 2, 20, 30, 45],
            }]
        };

        const lineConfig = {
            type: 'line',
            data: lineData,
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        };

        new Chart(
            $(this),
            lineConfig
        );
    });
    /*
     Bar Chart Default
     */
    $('.bargraphDefault').each(function() {
        const barData = {
            labels: defaultLabels,
            datasets: [{
                label: 'Example Dataset',
                data: [65, 59, 80, 81, 56, 55, 40],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)'
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)'
                ],
                borderWidth: 1
            }]
        };

        const barConfig = {
            type: 'bar',
            data: barData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: 'Example Bar Graph'
                    }
                }
            },
        };

        new Chart(
            $(this),
            barConfig
        );
    });

    /*
     Bar Chart Default
     */
    $('.piegraphDefault').each(function() {
        const pieData = {
            labels: ['Red', 'Blue', 'Yellow'],
            datasets: [
                {
                    label: 'Example Pie Graph',
                    data: [300, 50, 100],
                    backgroundColor: [
                        'rgb(255, 99, 132)',
                        'rgb(54, 162, 235)',
                        'rgb(255, 205, 86)',
                    ]
                }
            ]
        };

        const piConfig = {
            type: 'pie',
            data: pieData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: 'Example Pie Graph'
                    }
                }
            },
        };

        new Chart(
            $(this),
            piConfig
        );
    });

    /*
     Funnel Chart Default
     */
    $('.funnelgraphDefault').each(function() {
        console.log("initializing funnel chart")
        window.FacetTrak.functions.initializeFunnelChart($(this), ["Label 1", "Label 2", "Label 3", "Label 4"], [300, 200, 100, 10],
            []);
    });
});
